import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { WebformService, KeyValue } from '@app/services/webform.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'webform-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss'],
})
export class StepsComponent implements OnInit, OnDestroy {
  steps: KeyValue[] = [];
  currentPage: number = 0;
  #currentPageSub!: Subscription;
  #pagesSub!: Subscription;

  readonly #webform = inject(WebformService);
  readonly #cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.#currentPageSub = this.#webform.currentPage.subscribe((v: number) => {
      this.currentPage = v;
      this.#cdr.markForCheck();
    });
    this.#pagesSub = this.#webform.pages.subscribe((v: KeyValue[]) => {
      this.steps = v;
      this.#cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    if (this.#currentPageSub) this.#currentPageSub.unsubscribe;
    if (this.#pagesSub) this.#pagesSub.unsubscribe();
  }

  goTo(index: number): void {
    if (index > this.currentPage) {
      document?.dispatchEvent(new CustomEvent('webform:track:submit:incomplete'));
    }
    this.#webform.setCurrentPage(index);
  }
}
